import { Provider } from '@angular/core';
import { ACCESS_REASON_GATE } from '@asm/components-core/services/access-reason-gate';
import { AccessReasonService } from '../services/access-reason.service';

export function provideAsmAccessReason(): Provider[] {
  return [{ provide: ACCESS_REASON_GATE, useExisting: AccessReasonService }];
}
